import Constants from '~/config/Constants';
import type { IMember, IOrgInfo } from '~/domains/organization';
import type UserDomain from '~/services/UserService';
import $store from '~/services/StoreService';

export function isInvalidOrgMember(user: IMember) {
  return [Constants.OrgMemberStatus.PAYMENT_DUE, Constants.OrgMemberStatus.SUSPENDED].includes(user?.membershipStatus);
}

export function getTotalAvailableSeats(orgInfo: IOrgInfo | Record<string, never>, user: IMember | UserDomain | Record<string, never> = {}) {
  const totalMembersInOrg = orgInfo.admins?.concat(orgInfo.members) || [];
  const totalValidMembersInOrg = totalMembersInOrg.filter(ele => !isInvalidOrgMember(ele));
  const totalQuantity = user.quota?.instructors?.limit || orgInfo?.billing?.quantity || 1;
  const availableSeats = totalQuantity - totalValidMembersInOrg.length;

  if (availableSeats < 0) {
    return 0;
  }

  return availableSeats;
}

export function getTotalSeats(orgInfo: IOrgInfo, user: IMember | UserDomain | Record<string, never> = {}) {
  return user.quota?.instructors?.limit || orgInfo?.billing?.quantity || 1;
}

export function isCorporateUser() {
  return $store()?.getters['root/userService']?.isCorporate;
}
